module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('file-upload', {
    attrs: {
      "label-for": _vm.labelFor,
      "image-url": _vm.imageUrl,
      "min-resolution": _vm.minResolution,
      "disable-validation": _vm.disableValidation,
      "max-resolution": _vm.maxResolution,
      "preview-image": _vm.previewImage,
      "allowed-files": _vm.allowedFiles
    },
    on: {
      "file-info": _vm.fileInfo,
      "file-error": _vm.fileError
    }
  })
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-686b5a66","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/shared/FileUpload/FileUploadContainer.vue
// module id = 944
// module chunks = 6 8 9 10 11 12 31 46 51